import { ConnectorType } from "@/entities/DataAssociation/File.model";
import { QuickbooksIcon } from "./connectors/QuickbooksIcon";
import { ShareIcon } from "@heroicons/react/24/outline";
import { XeroIcon } from "./connectors/XeroIcon";

export const ConnectorIcon = ({
    connectorType,
    condensed = false,
}: {
    condensed?: boolean;
    connectorType: ConnectorType;
}) => {
    switch (connectorType) {
        case ConnectorType.QUICKBOOKS:
            return <QuickbooksIcon condensed={condensed} />;
        case ConnectorType.QUICKBOOKS_DESKTOP:
            return <QuickbooksIcon condensed={condensed} />;
        case ConnectorType.QUICKBOOKS_SANDBOX:
            return <QuickbooksIcon condensed={condensed} />;
        case ConnectorType.XERO:
            return <XeroIcon condensed={condensed} />;
        default:
            return <ShareIcon width={16} />;
    }
};
